
<template>
    <div class="main-layout2" ref="mainLayout">
        <nav>
            <div class="Logo-header flx">
                <div class="left">
                    <span class="name">牦牛酪蛋白产业数智平台管理后台</span>
                </div>
                <div class="menu">
                    <div class="item" :class="menuId == menu.id?'active':''" v-for="(menu,index) in menuList" :key="index" @click="clickMenu(menu)">
                        <span>{{menu.name}}</span>
                    </div>
                </div>
                <div class="right flx-lc">
                    <span class="user"><i></i>管理员</span>
                    <a class="link" @click="exitLogin">退出</a>
                </div>
            </div>
            <div class="submenu" v-if="subMenu.length">
                <div class="item" :class="subMenuId == menu.id?'active':''" v-for="(menu,index) in subMenu" :key="index"><span @click="clickSubMenu(menu)">{{menu.name}}</span></div>
            </div>
        </nav>
        <article ref="article">
            <!-- 内容区 -->
            <keep-alive>
                <div class="article_content">
                    <router-view :key="$route.fullPath"></router-view>
                </div>
            </keep-alive>
        </article>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                menuId: 1,
                subMenuId: 0,
                menuList: [{
                        id: 1,
                        name:'国际市场',
                        path: '/admin/international',
                        children: [{
                            id: 1,
                            name: '拍卖结果',
                        },{
                            id: 2,
                            name: 'GDT价格指数变化',
                        },{
                            id: 3,
                            name: '产品',
                        },{
                            id: 4,
                            name: '地图数据',
                        },{
                            id: 5,
                            name: '最新动态',
                        }]
                    },{
                        id: 2,
                        name:'国内市场',
                        path: '/admin/china',
                        children: [{
                            id: 1,
                            name: '近5年产量变化',
                        },{
                            id: 2,
                            name: '近5年各省份产量数据',
                        },{
                            id: 3,
                            name: '人均饮奶量变化',
                        },{
                            id: 6,
                            name: '友情链接',
                        },{
                            id: 4,
                            name: '地图数据',
                        },{
                            id: 5,
                            name: '最新动态',
                        },{
                            id: 7,
                            name: '产业链',
                        },{
                            id: 8,
                            name: '乳制品品牌TOP30',
                        },{
                            id: 9,
                            name: '茶饮品牌TOP10',
                        }]
                    },{
                        id: 3,
                        name:'甘孜市场',
                        path: '/admin/ganzi',
                        children: [{
                            id: 1,
                            name: '常见的牦牛',
                        },{
                            id: 2,
                            name: '工厂与奶渣原料地距离',
                        },{
                            id: 3,
                            name: '牦牛数量分布',
                        },{
                            id: 4,
                            name: '中国牦牛数量分布',
                        },{
                            id: 5,
                            name: '康巴圣德经营数据',
                        },{
                            id: 6,
                            name: '牦牛乳的相关产品及成分',
                        },{
                            id: 7,
                            name: '购买食物所考虑的因素',
                        },{
                            id: 8,
                            name: '酪蛋白的企业标准及视频',
                        },{
                            id: 9,
                            name: '曲拉回收可视化数据实时监控',
                        }]
                    }
                ],
                subMenu: [],
            }
        },
        created() {
            this.getCookie()
        },
        watch: {
            '$route': {
                handler(route){
                    // this.getCookie()
                    this.menuId = route.path.indexOf('international')>-1 ? 1:route.path.indexOf('china')>-1 ? 2:3
                    this.subMenuId = 1
                    let item = this.menuList.find(it => it.id == this.menuId)
                    this.subMenu = item && item.children ? item.children : []
                },
                immediate: true
            },
        },
        beforeDestroy(){
        },
        methods: {
            /** 退出登陆 */
            exitLogin() {
                sessionStorage.removeItem('username_1')
                this.$router.push('/login');
            },
            getCookie(){
                let cache = JSON.parse(sessionStorage.getItem('username_1'))
                this.userInfo = cache
                try {
                    if(cache){
                    }else{
                        alert('登录已过期，请重新登录')
                        this.$router.push('/login');
                    }
                } catch (e) {
                    console.log(e)
                    this.$message.error('用户非法进入页面');
                    this.$router.push('/login');
                    throw new Error('用户非法进入页面')
                }
            },
            clickMenu(val){
                this.menuId = val.id
                if(val.path){
                    this.$router.push(val.path)
                }
                if(val.children){
                    this.subMenu = val.children
                    this.subMenuId = this.subMenu[0].id
                    // let path = this.subMenu[0].path
                    // if(path){
                    //     this.$router.push(path)
                    // }
                }
            },
            clickSubMenu(val){
                this.subMenuId = val.id
            }
        }
    }
</script>

<style lang="less" scoped>
    @import '@/styles/common';
    @import '@/styles/layout/index2';
    .iframeContain{
        width: 100%;
        height: 100%;
        border: 0;
    }
    .popitem{
        cursor: pointer;
        display: block;
        color: #000;
        line-height: 1;
        padding: 10px 0;
        .link{
            color: #000;
        }
    }
</style>